import { BtnConfigSearchProduct } from "../../../../components/common/BtnConfigSearchProduct/BtnConfigSearchProduct";
import { SaveConfigurationButton } from "../ConfigurationControls/SaveConfigurationButton";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import { IndividualControlLayoutProps } from "@plansoft-configuration-renderer/components";
import { useSessionId } from "@plansoft-configuration-renderer/framework";
import { useSearch } from "@tanstack/react-router";

import { UtilsApplication } from "./variants/UtilsApplication";
import { UtilsProductView } from "./variants/UtilsProductView";

export function IndividualComponent(
  props: IndividualControlLayoutProps,
): JSX.Element {
  const { variant = "variantFallback", custom = {} } = props;
  const { t } = useTranslation();
  const sessionId = useSessionId();
  const { configurationId } = useSearch({
    strict: false,
  });

  let componentBody;
  switch (variant) {
    case "utils_ProductView":
      componentBody = <UtilsProductView />;
      break;
    case "utils_Professional":
      componentBody = <></>;
      break;
    case "utils_Application":
      componentBody = <UtilsApplication />;
      break;
    case "utils_ProfessionalSearch":
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BtnConfigSearchProduct
            sessionId={sessionId}
            path="/XAS_SELECTION/0"
          />
        </Box>
      );
      break;
    case "utils_ApplicationSearch":
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BtnConfigSearchProduct sessionId={sessionId} path="/" />
        </Box>
      );
      break;
    case "utils_AddProjectList": {
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <SaveConfigurationButton
            configurationId={configurationId}
            label={t("WEG:buttons.AddToProjectList")}
            fullWidth
          />
        </Box>
      );
      break;
    }

    default:
      componentBody = (
        <Alert>
          <AlertTitle>{variant}</AlertTitle>
          <code>{JSON.stringify(custom, null, 2)}22</code>
        </Alert>
      );
      break;
  }

  return <Box my={2}>{componentBody}</Box>;
}
